import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api, fileUrl, formatApiErrorDetail } from "../../lib/api";

export default function GymArtwork() {
  const [artwork, setArtwork] = useState([]);
  const [name, setName] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const load = () => api.get("/wholesale/artwork").then(({ data }) => setArtwork(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async () => {
    const file = fileRef.current?.files?.[0];
    if (!file) return toast.error("Choose a file");
    if (!name) return toast.error("Enter an artwork name");
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data: up } = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.post("/wholesale/artwork", { academy_id: "", name, file_id: up.id });
      toast.success("Artwork uploaded");
      setName("");
      if (fileRef.current) fileRef.current.value = "";
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="px-5 lg:px-8 py-8 max-w-4xl">
      <p className="font-mono text-emerald-400 uppercase tracking-widest text-xs">Academy</p>
      <h1 className="font-heading font-black uppercase text-4xl text-white mt-1">Logos & Artwork</h1>
      <p className="text-zinc-500 mt-1">Stored artwork speeds up ordering, reordering and production accuracy.</p>

      <div className="bg-[#121216] border border-white/10 rounded-lg p-6 mt-6">
        <h3 className="font-heading font-bold uppercase text-white text-lg mb-3">Upload New Artwork</h3>
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Artwork name (e.g. Ventura Logo)" className="w-full bg-[#0A0A0C] border border-white/15 rounded-md p-3 text-sm text-white outline-none mb-3" />
        <input ref={fileRef} type="file" data-testid="artwork-file" className="text-sm text-zinc-400 mb-3 block" accept="image/*,.pdf,.svg" />
        <button data-testid="artwork-upload" disabled={uploading} onClick={upload} className="btn-green inline-flex items-center gap-2 px-5 py-3 rounded-sm disabled:opacity-50">
          <Upload className="h-4 w-4" /> {uploading ? "Uploading…" : "Upload Artwork"}
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
        {artwork.map((a) => (
          <div key={a.id} className="bg-[#121216] border border-white/10 rounded-lg overflow-hidden">
            {a.file_id ? (
              <img src={fileUrl(`paragon-merch/uploads`)} alt={a.name} className="hidden" />
            ) : null}
            <div className="aspect-square bg-[#0A0A0C] flex items-center justify-center text-zinc-600 font-mono text-xs">
              {a.name}
            </div>
            <div className="p-3">
              <p className="text-white text-sm font-semibold truncate">{a.name}</p>
              <p className="font-mono text-[10px] uppercase text-emerald-400 mt-1">{a.status}</p>
            </div>
          </div>
        ))}
        {artwork.length === 0 && <p className="text-zinc-600 font-mono text-sm col-span-full">No artwork uploaded yet.</p>}
      </div>
    </div>
  );
}
